<h2 mat-dialog-title>Edit {{ data.entityName }} Mappings</h2>
<mat-dialog-content>
  <div style="padding-top: 8px; display: flex; flex-direction: column; gap: 16px;">
    <p>Assign items for <strong>{{ data.entityLabel }}</strong>.</p>
    
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Search items...</mat-label>
      <input matInput [(ngModel)]="searchQuery" placeholder="Type to search...">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <div style="max-height: 400px; overflow-y: auto; border: 1px solid #eee; border-radius: 4px; padding: 8px;">
      <div *ngIf="filteredItems.length === 0" style="padding: 16px; text-align: center; color: #666;">
        No items found.
      </div>
      
      <div *ngFor="let item of filteredItems" style="padding: 4px 8px;">
        <mat-checkbox 
          [checked]="selectedIds.has(data.getItemId(item))"
          (change)="toggleSelection(data.getItemId(item))">
          {{ data.getItemLabel(item) }}
        </mat-checkbox>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-flat-button color="primary" (click)="onSave()">Save Changes</button>
</mat-dialog-actions>
